module.exports = __webpack_public_path__ + "img/pg1.3759fc3a.png";